exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TfW5D,.VV23o{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}.VV23o{color:#2c7e07;font-size:15px;font-weight:500}.wZg14>button,.wZg14>input{margin:5px 0}", ""]);

// exports
exports.locals = {
	"root": "_2fxs3",
	"errorMessage": "TfW5D",
	"successMessage": "VV23o",
	"requestForm": "wZg14"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/DealerServiceForm/DealerServiceForm.css
// module id = 1880
// module chunks = 0 15 17 22 32